import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, useNavigate, NavLink } from 'react-router-dom';


import { FcBusinessman, FcSportsMode , FcFile, FcManager, FcPortraitMode, FcAutomotive, FcInternal, FcShipped, FcDonate, FcKindle } from "react-icons/fc";


import { DataContext } from '../init/getData';

import MemberTransaction from './memberTransaction/memberTransaction';
import TrainerTransaction from './trainerTransaction/trainerTransaction';
import Expenses from './expenses/expenses';

import { GiGymBag, GiWeightLiftingUp } from 'react-icons/gi';
import { FaUser, FaDumbbell, FaMoneyBillWave } from 'react-icons/fa';
import { CiInboxOut } from "react-icons/ci";
function TransactionsTab(props) {

  const { settingData, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('memberTransaction');

  useEffect(() => {

    navigate('/transactionsTab/memberTransaction');

  }, []);


  return (
    <div className="card" style={{ paddingTop: '0px', userSelect: 'none' }}>

      <div>

        
        <NavLink to="memberTransaction" onClick={() => setActiveTab('memberTransaction')}>
          <div className={`${activeTab === 'memberTransaction' ? 'tab-one active-link' : 'tab-one'}`} style={{ width: '12%' }}>
          <FcPortraitMode size={35} />
            <span className="tab-text">Member Transaction</span>
          </div>
        </NavLink>

        <NavLink to="trainerTransaction" onClick={() => setActiveTab('trainerTransaction')}>
          <div className={`${activeTab === 'trainerTransaction' ? 'tab-two active-link' : 'tab-two'}`} style={{ width: '12%' }}>
            <GiWeightLiftingUp color='rgb(255, 128, 0)'  size={30} />
            <span className="tab-text">Trainer Transaction</span>
          </div>
        </NavLink>

        

      </div>


      <Routes>

        <Route path='memberTransaction' element={<MemberTransaction />} />
        <Route path='trainerTransaction' element={<TrainerTransaction />} />
        <Route path='expenses' element={<Expenses />} />
     
      </Routes>

    </div>
  );
}

export default TransactionsTab;